import { axios } from '@/services/axios';

export const createRegistrar = (registrarData, currentScope) => {
    const res = axios.post('/TRSRegistrar', registrarData, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res;
};
